<template>

  <TsSection>
    <TsRow class="dark:text-idle-white">
      <TsColumn :append-class="isMobile && 'hidden'">
        <TsImage v-if="isDesktop"  src="/images/signin2.webp" class="hidden lg:block w-full rounded-lg" width="800" height="600" loading="lazy"/>
      </TsColumn>
      <TsColumn>
        <TsAuthentication view="reset-password"/>
      </TsColumn>
    </TsRow>
  </TsSection>


</template>


<script setup lang="ts">
const TsAuthentication = defineAsyncComponent(() => import('~/components/auth/TsAuthentication.vue'));

const { isMobile,isDesktop } = useDevice();
const authStore = useAuthStore();
const route = useRoute();

if(authStore.is_authenticated){
  navigateTo({ path: '/' })
}

if(!route.params.token){
  navigateTo({ path: '/login' })
}

authStore.reset_password_item.token = route.params.token;

useSeoMeta({
  title: `Toolstation | ${useTranslation('resetPassword' , 'Wachtwoord opnieuw instellen')}`
})

definePageMeta({
  layout: 'auth'
})
</script>